import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { Destination, useAddRecentContact } from '@vatom/sdk/react'
import { Status, Toast } from '@vatom/wombo'

import logger from '../../../../logger'
import { AppRoutes } from '../../../../navigators'

import { SendBtn, senderInterface } from '.'

export default function SendNft(props: senderInterface) {
  const { token, destination, userProfile } = props
  const navigation = useNavigation()
  const addRecentContactMutation = useAddRecentContact()

  const sendObject = async (): Promise<void> => {
    if (token) {
      // setIsLoading(true)
      try {
        // if (userProfile) RecentContacts.addRecentContact(userProfile)
        // if (!userProfile && destination) RecentContacts.addRecentDestinations(destination)
        const contactOrDestination = userProfile || (destination as Destination)
        if (contactOrDestination) addRecentContactMutation.mutate(contactOrDestination)
        navigation.navigate(AppRoutes.home)
        Toast({
          title: `Your NFT has been sent`,
          status: Status.success
        })
        logger.info('userProfile', userProfile)
        logger.info('destination', destination)

        // const response = await token.performAction('Transfer', destination.value)
        // logger.info(response)
        // Log analytics
        // setTransactionHash(response.hash)
      } catch (err) {
        logger.error(err)
        // Errors.show(err)
      }
      // finally {
      //   setIsLoading(false)
      // }
    }
  }

  return <SendBtn onPress={() => sendObject()} disabled={false} />
}
